import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { FaDiscord } from "react-icons/fa";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>

        {/* Render the "Live" button first */}
        {!props.isBlog && props.demoLink && (
          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
          >
            <CgWebsite /> &nbsp; View
          </Button>
        )}
        {"\n"}
        {"\n"}

        {/* Render the "Support" button second */}
        <Button
          variant="primary"
          href={props.ghLink}
          target="_blank"
          style={{ marginLeft: "10px" }}
        >
          <FaDiscord /> &nbsp; Support
        </Button>
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;
